/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.profileImage[_ngcontent-%COMP%] {\n  width:0;\n  height:0;\n\n}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvZ2l0bGFiLXJ1bm5lci9idWlsZHMvZDkwYzViY2YvMC9nYWlhL2dhaWEtdWktYW5ndWxhci9zcmMvYXBwL3VzZXIvbW9kaWZ5L21vZGlmeS5jb21wb25lbnQuY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUvZ2l0bGFiLXJ1bm5lci9idWlsZHMvZDkwYzViY2YvMC9nYWlhL2dhaWEtdWktYW5ndWxhci9zcmMvYXBwL3VzZXIvbW9kaWZ5L21vZGlmeS5jb21wb25lbnQuY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/$$_gendir/app/user/modify/modify.component.css.shim.ngstyle.ts